import { StyleSheet } from 'react-native'
import { TextInput, TextInputProps } from 'react-native-paper'
import colors from '../../constants/colors'

export const MelddTextArea = ({
  placeholder,
  value,
  onChangeText,
  minHeight = 350,
  ...props
}: TextInputProps & { minHeight?: number }) => {
  const styles = useStyle()
  return (
    <TextInput
      multiline
      mode="outlined"
      numberOfLines={4}
      style={{ ...styles.textArea, minHeight }}
      placeholder={placeholder}
      placeholderTextColor={colors.grey200}
      value={value}
      onChangeText={onChangeText}
      {...props}
    />
  )
}

const useStyle = () => {
  return StyleSheet.create({
    textArea: {
      backgroundColor: '#f5f2f7',
      padding: 15,
      marginBottom: 20,
      flex: 1,
      paddingBottom: 20,
      textAlignVertical: 'top',
      minHeight: 350, // This makes the button fix at the bottom, but if the screen is too short this will force the scroll
    },
  })
}
